import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcDeleteIcon, IcPlusIcon } from '@gem/icons';
import { IconButton, popupItemStyles } from '@gem/ui-kit';

import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { PopupInfoCard } from 'APP/components/PopupInfoCard/PopupInfoCard';
import { IStickerPackExtend } from 'APP/model/stickers/stickersModel.types';

import { useStickerPackPresenter } from './StickerPack.presenter';
import styles from './StickerPack.styles.m.scss';

interface StickerPacksItemProps {
  data: IStickerPackExtend;
  onStickerPackClick(stickerPack: IStickerPackExtend): void;
}
export const StickerPack: FC<StickerPacksItemProps> = observer(({ data, onStickerPackClick }) => {
  const presenter = useStickerPackPresenter({ pack: data, onStickerPackClick });

  return (
    <div
      className={classNames(
        popupItemStyles.container,
        popupItemStyles.interactive,
        styles.container
      )}
      role="button"
      tabIndex={0}
      onClick={presenter.onClick}
    >
      <PopupInfoCard
        type={AvatarTypes.Round_10}
        avatarTitle={presenter.avatarTitle}
        avatarUrl={presenter.avatarUrl}
        avatarBackgroundColorIndex="1"
        title={presenter.title}
        subtitle={presenter.subtitle}
      />
      <IconButton
        isLoading={presenter.isLoading}
        className={styles.icon}
        Icon={presenter.isAddedPack ? IcDeleteIcon : IcPlusIcon}
        onClick={presenter.toggle}
      />
    </div>
  );
});
